// extracted by mini-css-extract-plugin
export var content = "styles-module--content--d2935";
export var contentContainer = "styles-module--contentContainer--ffe67";
export var header = "styles-module--header--32312";
export var headerContent = "styles-module--headerContent--27060";
export var icon = "styles-module--icon--f7553";
export var isFirst = "styles-module--isFirst--17c06";
export var isOpen = "styles-module--isOpen--cfbac";
export var leftAligned = "styles-module--leftAligned--299b2";
export var outerContainer = "styles-module--outerContainer--2b710";
export var small = "styles-module--small--cef64";